import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@app/environment/environment';
import {
  ProjectIdeaCeationResponse,
  ProjectResponse,
} from '@app/models/project-setup.models';
import { FileResponse } from '@app/models/shared.models';
import { ProjectSetupCreateRequest } from '@app/models/project.models';
import { Observable } from 'rxjs';
import { IProjectSetupService } from './project-setup.service.interface';

@Injectable({ providedIn: 'root' })
export class ProjectSetupService implements IProjectSetupService {
  private readonly API_URL = environment.apiUrl;
  private readonly httpClient = inject(HttpClient);

  createProjectIdea(
    projectIdea: ProjectSetupCreateRequest
  ): Observable<ProjectResponse> {
    return this.httpClient.post<ProjectResponse>(
      `${this.API_URL}/ProjectSetup/Idea`,
      projectIdea
    );
  }

  updateProjectIdea(
    projectId: string,
    projectIdea: ProjectSetupCreateRequest
  ): Observable<ProjectResponse> {
    return this.httpClient.put<ProjectResponse>(
      `${this.API_URL}/ProjectSetup/${projectId}/Idea`,
      projectIdea
    );
  }

  getProjectIdea(projectId: string): Observable<ProjectIdeaCeationResponse> {
    return this.httpClient.get<ProjectIdeaCeationResponse>(
      `${this.API_URL}/ProjectSetup/${projectId}/Idea`
    );
  }

  getProjectBaseData(projectId: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.API_URL}/ProjectSetup/${projectId}/BaseData`
    );
  }

  getProjectFiles(
    projectId: string,
  ): Observable<FileResponse[] | { data: FileResponse[] }> {
    return this.httpClient.get<FileResponse[] | { data: FileResponse[] }>(
      `${this.API_URL}/ProjectSetup/${projectId}/Files`,
    );
  }

  getSection<TResponse>(
    projectId: string,
    section: string
  ): Observable<TResponse> {
    return this.httpClient.get<TResponse>(
      `${this.API_URL}/ProjectSetup/${projectId}/Section${section}`
    );
  }

  updateSection(
    projectId: string,
    section: string,
    sectionData: any
  ): Observable<any> {
    return this.httpClient.put<ProjectResponse>(
      `${this.API_URL}/ProjectSetup/${projectId}/Section${section}`,
      sectionData
    );
  }

  statusToDraft(projectId: string): Observable<void> {
    return this.httpClient.put<void>(
      `${this.API_URL}/ProjectSetup/${projectId}/StatusToDraft`,
      {}
    );
  }

  submitProjectForReview(projectId: string): Observable<void> {
    return this.httpClient.put<void>(
      `${this.API_URL}/ProjectSetup/${projectId}/SubmitForReview`,
      {},
    );
  }
}
